import React, { useState } from 'react';
import { UiComponent, EventComponent } from 'components';
import { useIsMobile, usePageOption } from 'hooks';
import { EventQuery } from 'queries';
import { SearchEventFilterType } from 'types';

function DesktopList() {
  const pageState = usePageOption();
  const [filter, setFilter] = useState<SearchEventFilterType>({});
  const { data } = EventQuery.useGetAll({
    page: pageState.pageOption.page,
    size: pageState.pageOption.size,
    ...filter,
  });

  return (
    <EventComponent.List
      toolbar={<EventComponent.Filter handleFilter={setFilter} />}
      {...pageState}
      totalPage={data?.totalPages}
      data={data?.data || []}
    />
  );
}

function List() {
  const isMobile = useIsMobile();

  const title = <UiComponent.PageTitle>행사목록</UiComponent.PageTitle>;

  if (isMobile) return <EventComponent.MobileList title={title} />;

  return (
    <>
      {title}
      <DesktopList />
    </>
  );
}

export default List;
